import { u as p } from "./window-BSUR27FD.mjs";
import { t as l } from "./breakpoints-DvaoDEis.mjs";
import { r as f } from "./index-ByKJWKwE.mjs";
import { useState as d, useEffect as b } from "react";
import { i as h } from "./const-BlLLRlwg.mjs";
const r = /* @__PURE__ */ new Map(), m = (e) => {
  const i = matchMedia(e), t = /* @__PURE__ */ new Set(), s = () => {
    for (const n of t)
      n(i.matches);
  };
  return i.addEventListener("change", s, { passive: !0 }), {
    mql: i,
    dispatchers: t,
    listener: s
  };
}, k = (e, i) => {
  let t = r.get(e);
  t || (t = m(e), r.set(e, t)), t.dispatchers.add(i), i(t.mql.matches);
}, v = (e, i) => {
  const t = r.get(e);
  if (t) {
    const { mql: s, dispatchers: n, listener: o } = t;
    n.delete(i), n.size === 0 && (r.delete(e), s.removeEventListener ? s.removeEventListener("change", o) : s.removeListener(o));
  }
};
function w(e, i = {}) {
  let { initializeWithValue: t = !0 } = i;
  h || (t = !1);
  const [s, n] = d(() => {
    if (t) {
      let o = r.get(e);
      return o || (o = m(e), r.set(e, o)), o.mql.matches;
    }
  });
  return b(() => (k(e, n), () => {
    v(e, n);
  }), [e]), s;
}
const a = (e, i) => w(f(e), i), y = (e, i = !1, t) => {
  const s = a(e, {
    initializeWithValue: !1,
    ...t
  });
  return s ?? i;
}, E = () => {
  var e;
  const i = a(l.breakpoints.up("largeDesktop"), {
    initializeWithValue: !1
  }), t = a(l.breakpoints.only("mediumDesktop"), {
    initializeWithValue: !1
  }), s = a(l.breakpoints.between("desktop", "mediumDesktop"), {
    initializeWithValue: !1
  }), n = a(l.breakpoints.only("tablet"), {
    initializeWithValue: !1
  }), o = a(l.breakpoints.only("mobile"), {
    initializeWithValue: !1
  });
  if (p()) return "mobile";
  const c = {
    desktop: s,
    largeDesktopUp: i,
    mediumDesktop: t,
    mobile: o,
    tablet: n
  };
  return (e = Object.keys(c).find((u) => c[u])) !== null && e !== void 0 ? e : "mobile";
};
export {
  E as a,
  y as u
};
//# sourceMappingURL=hooks-BC9ZhfBc.mjs.map
